import {useEffect, useState} from "react";
import {getBlogDataContent, getBlogHeader} from "../../../services/resources-support/BlogService";
import Header from "../../../components/ui/header/Header";
import BlogTabs from "../../../components/resources-support/blog/tabs/BlogTabs";
import LoadingSpinner from "../../../components/ui/loading-spinner/LoadingSpinner";

function Blog({language}) {
    const [content, setContent] = useState({});
    const [loading, setLoading] = useState(true);

    const formattedLanguage = language.toUpperCase();

    useEffect(() => {
        async function fetchData() {
            try {
                const [header, slidersContent] =
                    await Promise.all([
                        getBlogHeader(),
                        getBlogDataContent()
                    ]);

                const headerData = header.data.data[0];

                const slidersContentData = slidersContent.data.data.map(d => ({
                    ...d,
                    content: d.content.filter(c => c.isVisible === true)
                }))[0];

                setContent({
                    header: headerData,
                    slidersContent: slidersContentData
                });

                setLoading(false);
            } catch (error) {}
        }

        fetchData();
    }, []);

    if(loading === true) {
        return (
            <LoadingSpinner />
        );
    }

    return (
        <>
            {content.header && (
                <div>
                    <Header
                        title={content.header[`title${formattedLanguage}`]}
                        subtitle={content.header[`subtitle${formattedLanguage}`]}
                        sourcePath={`${content.header.image.url}`}
                    />

                    <BlogTabs slidersContent={content.slidersContent} language={language} />
                </div>
            )}
        </>
    );
}

export default Blog;